import { auth, getAuthProvider } from './../firebase/firebase'

// const USER = {
//   localId: 'C23Ci03TYOf2hhK8dWXz0GN6jRV2',
//   email: 'ralphsmith80@gmail.com',
//   emailVerified: true,
//   displayName: 'Ralph Smith',
//   providerUserInfo: [
//     {
//       providerId: 'google.com',
//       displayName: 'Ralph Smith',
//       photoUrl:
//         'https://lh5.googleusercontent.com/-goVKdtEW7fE/AAAAAAAAAAI/AAAAAAAAxZs/JDVB79V28cU/photo.jpg',
//       federatedId: '115388835016786923205',
//       email: 'ralphsmith80@gmail.com',
//       rawId: '115388835016786923205',
//     },
//   ],
//   photoUrl:
//     'https://lh5.googleusercontent.com/-goVKdtEW7fE/AAAAAAAAAAI/AAAAAAAAxZs/JDVB79V28cU/photo.jpg',
//   validSince: '1500434422',
//   lastLoginAt: '1504750147000',
//   createdAt: '1500434422000',
// }

const UnVerifiedEmailError = {
  code: 'auth/email-not-verified',
  message: 'Email not verified',
}
class User {
  get(params) {
    return new Promise((resolve, reject) => {
      auth.onAuthStateChanged(user => {
        if (user && !user.emailVerified) {
          auth.signOut()
          reject(UnVerifiedEmailError)
        } else if (user) {
          resolve(user)
        } else {
          reject('failed')
        }
      })
    })
  }
  signInWithProvider(provider) {
    const authProvider = getAuthProvider(provider)
    // return auth.signInWithRedirect(authProvider)
    return auth.signInWithPopup(authProvider)
  }
  signInWithEmailAndPassword(email, password) {
    return auth.signInWithEmailAndPassword(email, password).then(user => {
      if (!user.emailVerified) {
        auth.signOut()
        throw UnVerifiedEmailError
      }
      return user
    })
  }
  createUserWithEmailAndPassword(email, password) {
    return auth.createUserWithEmailAndPassword(email, password)
  }
  sendEmailVerification() {
    return auth.currentUser.sendEmailVerification()
  }
  sendPasswordResetEmail(email) {
    return auth.sendPasswordResetEmail(email)
  }
  signOut() {
    return auth.signOut()
  }
}

const user = new User()
export default user



// WEBPACK FOOTER //
// ./api/user/user.js